import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAjydGgwqlTXi31_D8bJp__BHiIg76Tfl0",
  authDomain: "peertutor-dbs.firebaseapp.com",
  projectId: "peertutor-dbs",
  storageBucket: "peertutor-dbs.firebasestorage.app",
  messagingSenderId: "1036076767309",
  appId: "1:1036076767309:web:3bdab796d50efdf1946404",
  measurementId: "G-CD74FNWDEP"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export const isDBSEmail = (email) => {
  const e = email?.toLowerCase();
  return e?.endsWith('@g.dbs.edu.hk') || e?.endsWith('@dbs.edu.hk');
};
export const isTeacherEmail = (email) => false;
